__turbopack_context__.v({
  "social": "social-media-links-list-module-scss-module__7yKb6G__social",
});
